import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { SparkLinePointDtoSchema } from '../contracts';

const _GetHiresTurnoversChartRequestDtoSchema = z.object({
  from: z.string().optional(),
  to: z.string().optional(),
  facilitiesIds: z.array(z.number()).optional(),
});

const SparkLineDtoSchema = z.object({
  granularity: z.enum(['day', 'week', 'month']),
  points: z.array(SparkLinePointDtoSchema),
});

const GetHiresTurnoversChartResponseDtoSchema = z.object({
  hires: SparkLineDtoSchema,
  turnovers: SparkLineDtoSchema,
});

export type GetHiresTurnoversChartRequestDto = z.infer<
  typeof _GetHiresTurnoversChartRequestDtoSchema
>;
export type GetHiresTurnoversChartResponseDto = z.infer<
  typeof GetHiresTurnoversChartResponseDtoSchema
>;

export const getHiresTurnoversChart = (
  params: GetHiresTurnoversChartRequestDto,
  config?: AxiosRequestConfig<GetHiresTurnoversChartRequestDto>
) => {
  return api
    .get('/staff/hires-turnovers-chart', { params, ...config })
    .then(responseContract(GetHiresTurnoversChartResponseDtoSchema));
};
